var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonument1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 157,
    viewBox: "0 0 289 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.29 127.291V153.391",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.292 113.708C281.292 114.887 281.905 116.286 282.224 117.437C282.513 118.475 282.783 119.808 283.216 120.781C283.886 122.29 285.021 124.281 285.021 125.959",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.527 112.376C266.322 112.376 276.242 112.643 286.09 112.643",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.924 127.824H285.818",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.658 107.316V142.206",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.924 142.472C255.03 143.429 256.158 144.336 256.581 145.135C256.809 145.567 257.448 145.776 257.572 146.334C257.695 146.888 257.957 147.459 258.268 147.946C259.468 149.832 260.108 151.775 261.049 153.658",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.402 107.848H254.925",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.34 116.371H254.395",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.871 127.291H253.595",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.137 142.739H258.122",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251.997 116.371H257.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.243 136.612V148.331",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.243 148.064H276.499",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M268.243 136.612H276.233",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M276.235 137.146V147.267",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M264.249 93.9994V103.055",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M264.785 102.255H273.041",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M271.976 93.9994V101.19",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M264.785 93.9994H271.976",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M245.337 93.4669V103.055",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M245.869 102.255H253.859",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M253.596 93.4669V101.99",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M245.607 93.9994H253.065",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.33 98.3749V154.752",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M223.819 134.841V141.557",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M229.073 134.917V142.097",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M223.742 134.686C223.742 133.699 225.095 132.679 226.024 132.679C226.53 132.679 226.892 132.939 227.37 132.992C227.598 133.018 228.032 133.304 228.177 133.49C228.506 133.913 228.587 134.401 228.76 134.918",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4709 134.841V141.557",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7256 134.917V142.097",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3943 134.686C38.3943 133.699 39.7471 132.679 40.6759 132.679C41.1822 132.679 41.5444 132.939 42.0226 132.992C42.2507 133.018 42.6847 133.304 42.8289 133.49C43.1579 133.913 43.2397 134.401 43.4121 134.918",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M234.202 134.952V141.668",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M239.457 135.029V142.208",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M234.126 134.798C234.126 133.81 235.478 132.791 236.407 132.791C236.913 132.791 237.276 133.051 237.754 133.104C237.982 133.129 238.416 133.416 238.56 133.601C238.889 134.024 238.971 134.512 239.143 135.029",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8547 134.952V141.668",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1094 135.028V142.208",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48.778 134.798C48.778 133.81 50.1308 132.791 51.0596 132.791C51.5659 132.791 51.9281 133.051 52.4063 133.104C52.6344 133.129 53.0683 133.416 53.2125 133.601C53.5416 134.024 53.6234 134.512 53.7958 135.029",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M245.009 134.952V141.668",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M250.263 135.029V142.208",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M244.932 134.798C244.932 133.81 246.285 132.791 247.214 132.791C247.72 132.791 248.082 133.051 248.56 133.104C248.789 133.129 249.223 133.416 249.367 133.601C249.696 134.024 249.778 134.512 249.95 135.029",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6608 134.952V141.668",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9156 135.029V142.208",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5845 134.798C59.5845 133.81 60.9373 132.791 61.8661 132.791C62.3724 132.791 62.7346 133.051 63.2127 133.104C63.4408 133.129 63.8748 133.416 64.019 133.601C64.348 134.024 64.4298 134.512 64.6023 135.029",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M199.904 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M205.911 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M211.913 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M217.915 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M223.922 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M229.924 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M235.931 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M241.933 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M247.935 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7945 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46.801 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8032 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8054 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8121 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8143 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8209 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8231 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8253 147.132V150.259",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M200.508 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M206.514 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M212.517 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M218.519 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M224.526 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M230.528 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M236.535 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M242.537 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M248.539 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7945 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M46.801 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8032 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8054 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8121 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8143 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8209 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8231 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8253 111.173V112.374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M206.451 126.526L212.63 120.347",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M211.801 120.585L217.267 126.051",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8144 126.526L76.9931 120.347",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1636 120.585L81.6294 126.051",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8276 149.601H192.048",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8276 144.197H192.048",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8276 138.794H192.048",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8276 133.39H192.048",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8276 127.985H192.048",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8276 122.582H192.048",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8276 117.179H192.048",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8502 96.9205V155.357",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2837 106.841V141.69",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6544 142.707H94.7053",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9955 106.696H93.8355",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6544 116.569H93.5437",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48929 127.721H93.774",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2236 127.989V153.687",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50675 112.73C6.50675 115.697 5.33982 118.491 4.42467 121.237C3.76995 123.201 2.2236 125.008 2.2236 127.185",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29071 112.462H33.0051",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0487 136.49V146.86",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3098 136.22H19.3947",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9645 136.332V146.453",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3098 147.015H19.8445",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5875 93.71V101.582",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5875 101.581H24.0098",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1205 94.3843V101.582",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9206 93.0346H24.0056",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9183 93.2598V101.919",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M35.927 101.581H43.2368",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5685 93.1472V101.244",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7017 93.71H42.3368",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2185 154.76C28.2099 153.549 28.4712 151.811 29.4107 150.567C29.8654 149.966 30.1047 149.258 30.5416 148.654C30.8827 148.181 31.0935 147.441 31.5159 147.079C32.1307 146.552 32.5088 145.351 32.9426 144.669C33.2487 144.188 33.7416 143.593 33.9517 143.173",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5237 85.5488V105.748",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86597 76.309V111.541",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04797 86.0868H287",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00105 80.822C8.6009 80.9062 10.1752 81.3623 11.7847 81.4242C15.7484 81.5767 19.742 81.4414 23.7093 81.4414C33.9361 81.4414 44.163 81.4414 54.3898 81.4414C78.6865 81.4414 102.983 81.4414 127.28 81.4414C152.563 81.4414 177.846 81.4414 203.129 81.4414C228.504 81.4414 304.629 81.4414 279.254 81.4414",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00105 75.8655H281.732",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M281.733 76.7942V111.484",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M235.584 85.7773V105.6",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M220.716 96.9272V105.6",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M165.89 96.9274V115.511",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M151.644 95.6868V116.439",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M137.401 95.6868V115.819",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M122.529 95.9986V115.512",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4013 96.9272V105.29",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6542 94.2886C54.076 94.2886 54.8543 93.2839 55.1096 92.9555C55.5759 92.356 56.6295 91.7706 57.37 91.6225C58.6909 91.3583 60.3694 90.2625 61.6524 91.0172C62.2012 91.34 62.8466 92.0978 63.4555 92.2085C63.6212 92.2387 64.2643 92.6459 64.3442 92.7817C64.5507 93.1327 64.9431 93.1575 65.1942 93.4772C65.4375 93.7868 65.8703 93.9242 66.1087 94.2306C66.3534 94.5453 66.5866 94.9183 66.8686 95.2159C67.2027 95.5686 67.68 96.5756 67.68 97.0705",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6804 96.2598C67.8298 96.2411 68.376 95.7174 68.4661 95.5643C68.5784 95.3734 68.9398 95.069 69.1294 94.9847C69.9283 94.6296 70.6196 93.8469 71.5056 93.5938C72.0657 93.4337 72.6898 93.0428 73.18 92.7308C73.5203 92.5143 74.158 92.6058 74.5452 92.5248C76.1365 92.1917 77.7195 92.2028 79.3621 92.2028C81.2425 92.2028 83.1229 92.2028 85.0033 92.2028C86.524 92.2028 88.2683 92.2115 89.7043 92.7244C90.7879 93.1114 91.9176 93.6047 92.7181 94.4052C93.0484 94.7355 93.4524 95.0986 93.8193 95.384C94.0805 95.5871 94.4644 95.9346 94.5727 96.2598",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8497 96.8386C95.8497 95.9709 96.7818 95.0769 97.4146 94.5847C98.1966 93.9765 99.4686 93.3908 100.435 93.1036C100.969 92.9446 101.61 92.6762 102.109 92.4338C102.719 92.1376 103.447 92.0489 104.08 91.8027C104.798 91.5232 105.859 91.6509 106.63 91.5323C107.399 91.414 108.22 91.3906 109 91.3906C110.675 91.3906 112.58 90.9409 114.229 91.3648C114.688 91.4831 115.245 91.6392 115.671 91.8285C116.22 92.0724 116.779 92.4549 117.358 92.6657C118.15 92.9534 118.841 93.3534 119.522 93.8248C120.256 94.3325 120.935 94.9068 121.686 95.3897C122.014 95.6009 122.231 95.9113 122.626 95.9113",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M122.975 96.0268C123.33 95.9477 123.891 95.1108 124.159 94.8419C124.464 94.5371 124.972 94.1977 125.067 93.7665C125.133 93.4698 125.442 93.4171 125.525 93.1289C125.641 92.7229 126.125 92.6274 126.426 92.4334C127.053 92.0307 127.724 91.7292 128.358 91.3258C128.753 91.0743 129.56 90.8106 130.052 90.8106C130.948 90.8106 132.088 90.4373 132.969 90.7205C133.368 90.8489 133.795 91.0773 134.167 91.2743C134.394 91.3944 134.816 91.5364 134.972 91.7444C135.352 92.2516 135.394 93.4676 135.957 93.7987C136.542 94.1427 137.063 94.8779 137.348 95.4472",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M137.469 95.5651C137.758 95.4929 138.069 94.791 138.28 94.5734C138.653 94.1902 139.082 93.798 139.491 93.4528C140.053 92.979 140.639 92.2723 141.32 91.9717C143.002 91.2285 144.489 90.9285 146.343 90.9285C147.122 90.9285 147.806 91.3062 148.474 91.6819C149.085 92.0256 149.37 92.5237 149.814 93.0665C150.079 93.3901 150.389 94.2012 150.748 94.4059C150.963 94.5291 151.406 95.2711 151.495 95.4492",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M151.491 95.796C152.038 95.6865 152.183 94.6382 152.708 94.405C152.856 94.3392 153.234 93.963 153.32 93.8254C153.493 93.5476 153.977 93.4769 154.221 93.2458C155.03 92.4791 155.886 91.9293 156.945 91.5586C158.224 91.111 159.747 91.2753 161.086 91.2753C161.778 91.2753 162.305 91.8691 162.799 92.2734C163.757 93.0576 165.4 94.397 165.4 95.796",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M166.017 96.9451C166.063 96.9392 166.481 96.2219 166.559 96.1005C166.935 95.5168 167.428 95.0615 167.934 94.5923C168.337 94.2179 168.661 93.8429 169.16 93.4996C169.766 93.0834 170.665 92.7102 171.399 92.6014C172.316 92.4656 173.326 92.0446 174.221 91.7568C175.263 91.4219 176.315 91.2821 177.385 91.1267C179.257 90.855 181.129 90.9122 183.029 90.9122C183.965 90.9122 184.984 90.8125 185.858 91.2205C186.485 91.5132 187.156 91.7926 187.728 92.1858C188.34 92.6065 189.08 92.8703 189.665 93.3253C189.879 93.4911 190.228 93.5121 190.389 93.7141C190.591 93.9657 190.824 94.1091 191.087 94.2906C191.492 94.5713 191.804 94.9812 192.146 95.3229C192.807 95.984 193.484 96.8603 193.888 97.669",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M193.893 96.8243C194.428 95.8613 195.233 95.123 196.005 94.3508C196.481 93.8744 197.087 92.9165 197.768 92.7219C198.47 92.5213 199.103 92.0547 199.812 91.8773C200.38 91.7355 200.97 91.5988 201.522 91.4215C202.84 90.9977 204.489 91.1534 205.865 91.1534C207.379 91.1534 208.929 91.2216 210.423 91.455C211.898 91.6855 213.55 91.7619 214.948 92.2996C215.279 92.427 216.228 92.651 216.45 92.9096C216.644 93.1365 217.4 93.5329 217.69 93.6604C218.32 93.9379 218.52 94.9362 219.111 95.3161C219.507 95.5708 219.753 95.8154 219.955 96.221",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M220.676 96.4628C221.743 96.4628 222.054 93.7075 222.874 93.0844C224.183 92.0899 225.397 91.2745 227.097 91.2745C228.011 91.2745 229.065 91.1279 229.966 91.3013C230.434 91.3913 230.924 91.6515 231.387 91.7839C231.732 91.8823 231.948 92.0802 232.259 92.2398C232.968 92.6043 233.523 93.1666 234.162 93.634C234.504 93.8837 235.091 94.2845 235.275 94.6529",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2922 75.7123C11.2922 72.5374 11.1462 69.2579 11.1462 66.0112C11.1462 64.7812 10.897 63.2659 11.1786 62.0691C11.3999 61.1287 11.7302 60.1456 11.7302 59.1815C11.7302 58.547 12.1682 57.9658 12.1682 57.3159C12.1682 55.8802 12.3568 54.271 12.6143 52.8547C12.9585 50.9616 13.2894 48.9986 13.9932 47.1687C14.6344 45.5016 14.8897 43.601 15.2667 41.9044C15.5148 40.7881 15.9899 39.8049 16.3698 38.741C16.4964 38.3866 16.9629 37.3252 17.2783 37.1674",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7315 37.0843H28.3782",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3757 37.5571C29.5623 38.7437 30.3686 40.3795 30.8939 41.9552C31.3174 43.2258 31.752 44.3983 32.188 45.7063C33.3333 49.1424 33.4121 52.8543 33.4121 56.5224C33.4121 58.3029 33.659 60.1524 33.7269 61.9174C33.7605 62.791 33.971 63.6258 34.1641 64.4706C34.353 65.2971 34.199 66.3055 34.199 67.1549C34.199 68.5804 34.6712 69.9872 34.6712 71.3957C34.6712 72.8226 34.5138 74.0744 34.5138 75.4878",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M16.288 75.2242C16.288 74.4703 16.1758 73.6114 16.3902 72.8881C16.5095 72.4854 16.4752 71.9469 16.5435 71.5376C16.6182 71.0893 16.8136 70.6348 16.8136 70.1725C16.8136 68.3297 16.6822 66.5548 16.6822 64.7119C16.6822 62.7385 17.153 60.8132 17.5728 58.901C17.732 58.1758 17.8095 57.4031 18.0619 56.6964C18.1775 56.3728 18.5428 54.9776 18.7846 54.8567",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9198 53.9382H26.2783",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2772 54.7261C26.6401 56.686 27.0855 58.5771 27.6204 60.4495C27.8803 61.3589 28.028 62.3129 28.1241 63.2746C28.2282 64.315 28.5152 65.3353 28.6352 66.3553C28.8467 68.1532 29.1681 69.8913 29.1681 71.7355C29.1681 73.0837 29.2995 74.4392 29.2995 75.7506",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1036 69.0485V74.5674",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3606 68.9167H24.5655",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7014 69.8363V74.304",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0686 32.568H26.3202",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2485 28.1462H24.3566",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M254.793 75.7123C254.793 72.5374 254.647 69.2579 254.647 66.0112C254.647 64.7812 254.398 63.2659 254.68 62.0691C254.901 61.1287 255.231 60.1456 255.231 59.1815C255.231 58.547 255.669 57.9658 255.669 57.3159C255.669 55.8802 255.858 54.271 256.116 52.8547C256.46 50.9616 256.791 48.9986 257.494 47.1687C258.136 45.5016 258.391 43.601 258.768 41.9044C259.016 40.7881 259.491 39.8049 259.871 38.741C259.998 38.3866 260.464 37.3252 260.78 37.1674",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M260.233 37.0843H271.879",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M271.877 37.5571C273.063 38.7437 273.87 40.3795 274.395 41.9552C274.819 43.2258 275.253 44.3983 275.689 45.7063C276.834 49.1424 276.913 52.8543 276.913 56.5224C276.913 58.3029 277.16 60.1524 277.228 61.9174C277.262 62.791 277.472 63.6258 277.665 64.4706C277.854 65.2971 277.7 66.3055 277.7 67.1549C277.7 68.5804 278.172 69.9872 278.172 71.3957C278.172 72.8226 278.015 74.0744 278.015 75.4878",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M259.789 75.2242C259.789 74.4703 259.677 73.6114 259.891 72.8881C260.011 72.4854 259.976 71.9469 260.045 71.5376C260.119 71.0893 260.315 70.6348 260.315 70.1725C260.315 68.3297 260.183 66.5548 260.183 64.7119C260.183 62.7385 260.654 60.8132 261.074 58.901C261.233 58.1758 261.311 57.4031 261.563 56.6964C261.679 56.3728 262.044 54.9776 262.286 54.8567",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M262.421 53.9382H269.779",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M269.779 54.7261C270.142 56.686 270.587 58.5771 271.122 60.4495C271.382 61.3589 271.529 62.3129 271.626 63.2746C271.73 64.315 272.017 65.3353 272.137 66.3553C272.348 68.1532 272.669 69.8913 272.669 71.7355C272.669 73.0837 272.801 74.4392 272.801 75.7506",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M263.605 69.0485V74.5674",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M263.862 68.9167H268.067",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M268.203 69.8363V74.304",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M261.57 32.568H269.822",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M262.75 28.1462H267.858",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2433 75.7737C55.1567 75.3405 54.7088 75.0112 54.5478 74.6356C54.4378 74.379 54.2628 73.7407 54.0177 73.6045C53.4675 73.2989 53.4924 72.508 53.4924 71.9655C53.4924 71.2336 53.9935 70.5097 54.2803 69.8644C54.4555 69.4701 54.8554 69.1642 54.9612 68.7506C55.074 68.3096 55.4341 67.8215 55.681 67.4374C56.1942 66.6392 56.7006 65.8539 57.2763 65.0932C57.6454 64.6054 58.1566 64.0938 58.3852 63.5222C58.5588 63.0883 58.9269 62.7327 59.0904 62.2966C59.3642 61.5665 60.1458 60.7686 60.1458 59.9718C60.1458 59.8614 60.2334 59.5315 60.2334 59.5778C60.2334 60.0052 60.4245 60.5407 60.5155 60.9591C60.6979 61.7984 61.0821 62.6384 61.3909 63.4104C61.5227 63.7398 61.7901 64.0024 61.8967 64.349C62.0006 64.6864 62.2436 65.1231 62.4658 65.3947C62.8204 65.8282 63.4133 66.2475 63.8665 66.5814C64.2249 66.8456 64.5629 67.1076 64.8733 67.418C65.0492 67.5939 65.3002 67.8923 65.4861 68.0016C65.9637 68.2826 66.1251 68.9367 66.5366 69.2273C66.6887 69.3346 66.9153 69.8234 66.9744 70.0006C67.0945 70.3609 67.1791 70.7036 67.2808 71.09C67.5966 72.2902 67.7812 74.0571 66.4491 74.7231",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M222.67 75.7737C222.583 75.3405 222.136 75.0112 221.975 74.6356C221.865 74.379 221.689 73.7407 221.444 73.6045C220.894 73.2989 220.919 72.508 220.919 71.9655C220.919 71.2336 221.42 70.5097 221.707 69.8644C221.882 69.4701 222.282 69.1642 222.388 68.7506C222.501 68.3096 222.861 67.8215 223.108 67.4374C223.621 66.6392 224.127 65.8539 224.703 65.0932C225.072 64.6054 225.583 64.0938 225.812 63.5222C225.985 63.0883 226.354 62.7327 226.517 62.2966C226.791 61.5665 227.573 60.7686 227.573 59.9718C227.573 59.8614 227.66 59.5315 227.66 59.5778C227.66 60.0052 227.851 60.5407 227.942 60.9591C228.125 61.7984 228.509 62.6384 228.818 63.4104C228.949 63.7398 229.217 64.0024 229.323 64.349C229.427 64.6864 229.67 65.1231 229.893 65.3947C230.247 65.8282 230.84 66.2475 231.293 66.5814C231.652 66.8456 231.99 67.1076 232.3 67.418C232.476 67.5939 232.727 67.8923 232.913 68.0016C233.39 68.2826 233.552 68.9367 233.963 69.2273C234.115 69.3346 234.342 69.8234 234.401 70.0006C234.521 70.3609 234.606 70.7036 234.707 71.09C235.023 72.2902 235.208 74.0571 233.876 74.7231",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5867 75.0341C87.5867 72.8489 87.5867 70.6637 87.5867 68.4784C87.5867 67.4732 87.7497 66.4417 88.042 65.492C88.3205 64.5867 88.0784 63.2014 88.0784 62.2597C88.0784 60.0887 88.2245 57.4736 88.8614 55.4035C89.4357 53.537 89.2256 51.333 89.2256 49.385C89.2256 48.4022 89.3895 47.367 89.3895 46.435C89.3895 45.3985 89.7459 44.5853 89.8721 43.576C89.9814 42.7013 90.108 41.816 90.2181 40.9355C90.3775 39.6605 90.9279 38.3949 91.0284 37.1387C91.2988 33.7593 92.6654 30.4594 94.1424 27.5055",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3048 27.3412H106.105",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M106.435 27.8331C106.485 28.3269 106.998 28.6102 107.082 29.0714C107.21 29.7794 107.665 30.5283 107.737 31.2111C107.825 32.0453 108.273 33.4616 108.803 34.1429C109.037 34.4437 109.012 35.0129 109.094 35.3721C109.205 35.8567 109.516 36.4123 109.549 36.8836C109.639 38.1448 110.279 39.3258 110.369 40.5802C110.456 41.805 110.86 42.9499 110.86 44.2223C110.86 45.3165 111.024 46.3462 111.024 47.4182C111.024 48.4442 111.165 49.6101 111.388 50.6141C111.623 51.6707 111.516 52.8078 111.516 53.8919C111.516 56.0069 111.392 58.2031 111.689 60.2837C111.838 61.3303 111.844 62.358 111.844 63.434C111.844 64.3678 112.134 65.2175 112.171 66.1474C112.23 67.6003 112.335 69.1717 112.335 70.6908C112.335 71.3967 112.134 72.487 112.499 73.1037C112.8 73.6108 113.071 74.0468 113.319 74.5423",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6362 74.8702C93.4183 74.7349 93.1612 72.0303 93.1612 71.1826C93.1612 69.2348 93.6049 68.2611 94.6727 66.7485C95.0912 66.1555 96.1891 65.8852 96.7122 65.4009C97.0407 65.0967 97.5018 65.0686 97.8412 64.7909C98.2339 64.4695 98.5774 64.129 98.9703 63.8075C99.9564 63.0007 101.192 60.9777 101.192 59.6283",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M100.699 59.7915C100.885 61.8381 102.25 63.665 103.194 65.3638C103.495 65.9057 104.292 66.4547 104.76 66.8753C105.251 67.3172 106.02 67.4986 106.471 67.9497C106.943 68.4215 107.265 68.6647 107.546 69.2972C107.837 69.953 107.746 70.717 107.746 71.4278C107.746 72.2841 107.717 72.8424 107.254 73.5948C106.897 74.1759 106.795 75.2959 106.107 75.5251",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9761 66.512C93.9761 61.9303 94.8191 57.5256 95.2964 52.9909C95.4507 51.5247 96.0241 50.1349 96.1067 48.6478C96.1917 47.119 97.254 45.5203 97.254 44.0588",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9255 44.8772H103.153",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M103.319 44.714C104.092 46.8781 105.322 48.7714 105.942 50.9418C106.491 52.8658 106.89 54.8253 107.244 56.7691C107.6 58.7302 107.417 60.8691 107.417 62.8695C107.417 64.5206 107.417 66.1716 107.417 67.8227",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7819 23.0804H104.468",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0922 18.1634H102.665",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M112.825 67.8222C113.871 66.892 114.776 65.7562 115.693 64.6354C116.782 63.304 118.22 62.1975 118.552 60.3742C118.666 59.7472 118.725 59.206 118.725 58.5623C118.725 57.2459 119.32 59.1668 119.417 59.5548C119.576 60.19 119.938 60.7593 120.2 61.3485C120.397 61.792 120.774 62.686 121.183 62.9419C121.634 63.2237 122.034 63.8296 122.421 64.2166C122.85 64.6456 123.472 64.8848 123.878 65.291C124.647 66.0598 125.923 66.3425 126.273 67.5673C126.634 68.8301 127.247 69.7554 127.247 71.1365C127.247 72.0805 127.142 72.6341 126.674 73.4765C126.343 74.0722 125.772 74.4582 125.772 75.1973",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M201.737 74.3804C201.737 72.1951 201.737 70.0099 201.737 67.8247C201.737 66.8194 201.574 65.788 201.282 64.8382C201.003 63.933 201.245 62.5476 201.245 61.6059C201.245 59.435 201.099 56.8198 200.462 54.7498C199.888 52.8833 200.098 50.6793 200.098 48.7313C200.098 47.7485 199.934 46.7133 199.934 45.7812C199.934 44.7447 199.578 43.9315 199.452 42.9222C199.342 42.0476 199.216 41.1623 199.106 40.2818C198.946 39.0067 198.396 37.7412 198.295 36.4849C198.025 33.1056 196.658 29.8057 195.181 26.8517",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M195.019 26.6873H183.219",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M182.888 27.1793C182.839 27.6731 182.326 27.9564 182.242 28.4176C182.113 29.1256 181.658 29.8745 181.586 30.5573C181.499 31.3915 181.051 32.8078 180.521 33.4891C180.287 33.7899 180.312 34.3591 180.23 34.7183C180.119 35.2029 179.808 35.7584 179.774 36.2298C179.684 37.491 179.045 38.672 178.955 39.9264C178.867 41.1512 178.463 42.2961 178.463 43.5685C178.463 44.6627 178.299 45.6924 178.299 46.7644C178.299 47.7904 178.158 48.9563 177.935 49.9602C177.7 51.0169 177.808 52.154 177.808 53.2381C177.808 55.3531 177.932 57.5493 177.635 59.6299C177.485 60.6764 177.48 61.7042 177.48 62.7802C177.48 63.7139 177.189 64.5637 177.152 65.4936C177.094 66.9464 176.988 68.5179 176.988 70.037C176.988 70.7429 177.19 71.8332 176.824 72.4498C176.524 72.957 176.253 73.393 176.005 73.8885",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M194.688 74.2164C195.906 74.0811 196.163 71.3766 196.163 70.5289C196.163 68.581 195.719 67.6074 194.651 66.0947C194.233 65.5017 193.135 65.2314 192.612 64.7471C192.283 64.443 191.822 64.4148 191.483 64.1371C191.09 63.8158 190.746 63.4752 190.354 63.1537C189.367 62.3469 188.132 60.3239 188.132 58.9745",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M188.625 59.1378C188.439 61.1844 187.074 63.0112 186.13 64.7101C185.829 65.252 185.031 65.801 184.564 66.2215C184.073 66.6635 183.303 66.8449 182.852 67.2959C182.38 67.7677 182.059 68.011 181.778 68.6435C181.486 69.2992 181.578 70.0633 181.578 70.7741C181.578 71.6304 181.606 72.1887 182.069 72.9411C182.427 73.5222 182.529 74.6422 183.216 74.8714",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M195.347 65.8582C195.347 61.2765 194.505 56.8718 194.027 52.3372C193.873 50.8709 193.3 49.4811 193.217 47.994C193.132 46.4652 192.07 44.8665 192.07 43.4051",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M192.398 44.2234H186.17",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M186.004 44.0602C185.231 46.2243 184.002 48.1176 183.382 50.2881C182.832 52.2121 182.433 54.1715 182.08 56.1153C181.723 58.0765 181.907 60.2153 181.907 62.2157C181.907 63.8668 181.907 65.5179 181.907 67.1689",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M193.542 22.4266H184.856",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M192.232 17.5096H186.659",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M176.499 67.1684C175.452 66.2382 174.548 65.1024 173.631 63.9816C172.541 62.6502 171.103 61.5437 170.772 59.7204C170.658 59.0934 170.599 58.5522 170.599 57.9085C170.599 56.5921 170.004 58.513 169.907 58.901C169.748 59.5362 169.386 60.1055 169.124 60.6947C168.927 61.1382 168.55 62.0322 168.14 62.2881C167.69 62.5699 167.289 63.1758 166.902 63.5628C166.473 63.9918 165.851 64.231 165.445 64.6372C164.676 65.406 163.401 65.6887 163.051 66.9135C162.69 68.1763 162.076 69.1016 162.076 70.4827C162.076 71.4267 162.182 71.9803 162.65 72.8227C162.981 73.4184 163.551 73.8044 163.551 74.5435",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M130.751 74.989C130.751 73.308 130.774 71.6886 130.519 70.032C130.392 69.2034 130.093 68.6408 130.093 67.7666C130.093 66.9622 130.224 66.035 130.081 65.2454C129.404 61.5248 129.874 57.3309 129.874 53.5165C129.874 50.1509 129.874 46.7853 129.874 43.4197C129.874 41.9996 130.062 40.6055 130.093 39.2056C130.113 38.3162 130.231 37.4242 130.483 36.5748C130.641 36.0387 130.364 35.3822 130.58 34.8697C130.905 34.0973 130.462 33.0649 130.86 32.3486C131.402 31.3732 131.405 30.1183 131.64 29.0601C132.12 26.9003 132.897 24.8275 133.369 22.7024C133.661 21.3889 134.258 19.8109 134.258 18.4761C134.258 17.3121 135.047 16.3378 135.135 15.1876C135.189 14.494 135.945 14.0605 136.012 13.385C136.045 13.0557 136.166 12.6956 136.402 12.4594C136.837 12.0239 137.498 11.2897 137.766 10.7543",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M137.987 10.3164H150.921",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M150.919 10.7543C151.353 10.8628 151.812 12.4628 152.015 12.8248C152.485 13.6649 152.704 14.5549 153.221 15.3581C153.84 16.3223 154.405 17.6253 154.816 18.6953C155.345 20.0696 156.009 21.5537 156.192 23.019C156.346 24.2483 157.057 25.2485 157.057 26.5389C157.057 29.4333 157.934 32.2823 157.934 35.1864C157.934 37.9877 157.934 40.7889 157.934 43.5902C157.934 46.4909 159.249 49.2693 159.249 52.189C159.249 54.8522 159.249 57.5155 159.249 60.1787C159.249 65.0424 159.249 69.9061 159.249 74.7698",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M136.669 74.5507C135.529 74.5507 134.709 71.1634 134.428 70.2148C134.07 69.0092 134.379 68.2061 134.695 67.0968C134.939 66.2441 135.862 64.5505 136.669 64.0763C137.744 63.4435 138.725 62.4424 139.75 61.7378C140.634 61.1299 142.54 60.068 142.978 59.034C143.705 57.3153 144.561 56.1306 144.561 54.1622",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M144.781 54.6003C144.781 56.5874 146.536 58.3825 147.631 59.7522C148.263 60.5413 148.9 61.5183 149.714 62.1516C150.254 62.5711 151.717 63.5666 151.797 64.2465C151.893 65.0632 152.869 66.3671 153.331 67.0478C153.92 67.9136 153.77 69.0482 153.77 70.0561C153.77 72.2695 152.751 73.9584 151.797 75.8657",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M142.152 27.8536H147.413",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M147.416 28.0731C148.555 29.3264 148.88 31.5558 149.486 33.1154C150.015 34.4749 150.102 35.9014 150.594 37.2808C151.158 38.8593 150.923 40.9078 150.923 42.5667C150.923 44.4911 150.923 46.4154 150.923 48.3398C150.923 52.9135 151.8 57.304 151.8 61.8347",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M142.152 42.3232V50.8733",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M143.467 50.2155H146.536",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M146.096 42.7623V51.0931",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M142.152 42.9807H145.002",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M137.802 62.773C137.802 59.9906 137.802 57.2081 137.802 54.4257C137.802 52.9499 138.328 51.4922 138.328 50.0293C138.328 48.8372 138.02 47.1857 138.357 46.0492C139.302 42.8597 138.377 39.4317 139.182 36.212C139.632 34.4129 139.945 32.5873 140.497 30.8224C140.599 30.4949 140.75 30.2052 140.855 29.8804C140.944 29.6014 140.873 29.2443 140.986 28.9894C141.107 28.7166 141.431 27.8977 141.614 27.8063",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M140.063 5.94199H148.82",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M141.841 1.42566H146.904",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonument1);
export default __webpack_public_path__ + "static/media/monument1.a6b24b1131f77139a20f0d6a69d022e2.svg";
export { ForwardRef as ReactComponent };